import { useState, useEffect } from "react";
import { Cookie, X } from "lucide-react";

const COOKIE_CONSENT_KEY = "yesod_cookie_consent";

export const hasCookieConsent = () => localStorage.getItem(COOKIE_CONSENT_KEY) === "true";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem(COOKIE_CONSENT_KEY) === null) {
      const t = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "true");
    setVisible(false);
    window.dispatchEvent(new Event("cookie-consent-granted"));
  };

  const dismiss = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, "false");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-2 sm:p-4 animate-in slide-in-from-bottom-6 duration-500" dir="rtl">
      <div className="mx-auto max-w-2xl rounded-xl sm:rounded-2xl border border-border bg-card shadow-2xl overflow-hidden">
        <div className="h-0.5 sm:h-1 w-full gradient-accent" />
        <div className="p-3 sm:p-5">
          {/* Mobile: compact single-row layout */}
          <div className="flex items-center gap-2 sm:hidden">
            <Cookie size={16} className="shrink-0 text-primary" />
            <p className="flex-1 text-[11px] text-muted-foreground leading-tight">
              האתר משתמש בעוגיות לחוויית גלישה טובה יותר 🍪
            </p>
            <button
              onClick={accept}
              className="gradient-accent px-3 py-1.5 rounded-lg text-[11px] font-bold text-accent-foreground shrink-0"
            >
              אישור
            </button>
            <button
              onClick={dismiss}
              className="shrink-0 rounded-full p-1 text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
              aria-label="סגור"
            >
              <X size={14} />
            </button>
          </div>

          {/* Desktop: full layout */}
          <div className="hidden sm:block">
            <div className="flex items-start gap-4">
              <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl gradient-hero text-primary-foreground">
                <Cookie size={22} />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-bold text-foreground mb-1">
                  כמו שכל פרויקט צריך יסודות חזקים 🏗️
                </h3>
                <p className="text-xs text-muted-foreground leading-relaxed">
                  המערכת שלנו צריכה &lsquo;עוגיות&rsquo; (Cookies) כדי לעמוד יציב ולעבוד חלק.
                  אנחנו משתמשים בטכנולוגיה כדי לבנות לך חוויית גלישה בסטנדרט של מגדל יוקרה,
                  מותאמת אישית, מהירה ובטוחה.
                </p>
              </div>
              <button
                onClick={dismiss}
                className="shrink-0 rounded-full p-1.5 text-muted-foreground hover:bg-muted hover:text-foreground transition-colors"
                aria-label="סגור"
              >
                <X size={16} />
              </button>
            </div>
            <div className="flex items-center gap-3 mt-4 justify-end">
              <button
                onClick={dismiss}
                className="px-4 py-2 rounded-lg text-xs font-medium text-muted-foreground hover:text-foreground hover:bg-muted transition-colors"
              >
                סגור
              </button>
              <button
                onClick={accept}
                className="gradient-accent px-6 py-2 rounded-lg text-xs font-bold text-accent-foreground shadow-md hover:opacity-90 transition-opacity"
              >
                אישור ✓
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
